module.exports = __webpack_public_path__ + "img/jp1@2x.3706ff34.png";